import { BasePage } from '@/components/ui/base-page'

export function VerticalFarmsPage() {
  return (
    <BasePage
      title="Vertical Farms"
      description="Franchised vertical farming — financing and solutions for indoor and vertical agriculture."
    >
      <div className="prose dark:prose-invert max-w-none">
        <p>Our vertical farms franchise offering supports indoor and vertical farming ventures. Content can be expanded here.</p>
      </div>
    </BasePage>
  )
}
